import type { IFormGenContext, IFormGenSchema, TJSONSchema } from "@artifact-management/json-dynamic-form";
import type { FromSchema } from "json-schema-to-ts";
import type { BaseSyntheticEvent } from "react";
import type { DeepPartial, DefaultValues } from "react-hook-form";
import { FormGenControlled } from "./Controlled";
import { type TResetForm, useFormGen } from "./logics";

export interface IFormGenProps<Schema extends TJSONSchema, Values = FromSchema<Schema>> {
  schema: IFormGenSchema<Schema>;
  defaultValues?: DefaultValues<Values>;
  context?: IFormGenContext;
  onChange?: (data: DeepPartial<Values>) => void;
  onSubmit?: (data: Values) => void;
  renderActions?: (submit: (event?: BaseSyntheticEvent) => void, reset: TResetForm<Values>) => React.ReactNode;
}

export const FormGen = <Schema extends TJSONSchema, Values = FromSchema<Schema>>({
  schema,
  defaultValues,
  context,
  onChange,
  onSubmit,
  renderActions,
}: IFormGenProps<Schema, Values>) => {
  const { formControls, parsedJsonSchema } = useFormGen({ schema, defaultValues, context, onChange });

  return (
    <FormGenControlled
      schema={schema}
      parsedJsonSchema={parsedJsonSchema}
      formControls={formControls}
      context={context}
      onSubmit={onSubmit}
      renderActions={renderActions}
    />
  );
};

export { FormGenControlled } from "./Controlled";
export { useFormGen } from "./logics";
export { formSchema } from "./FormGen.stories";
